import { Injectable } from '@angular/core';
import { UtilService } from '@app-shared/services/util.service';
import { AdminService } from '@app/admin/admin.service';

@Injectable({
  providedIn: 'root',
})
export class AuthguardServiceService {
  menuAccessList = localStorage.getItem('menu_access');
  menuAccess = this.menuAccessList
    ? JSON.parse(this.util.decrypt(this.menuAccessList))
    : [];

  constructor(private util: UtilService, private adminSrvc: AdminService) {}

  gettoken() {
    return !!localStorage.getItem('username');
  }

  isEquivalent(value1: string, value2: string) {
    return value1.toLowerCase() === value2.toLowerCase();
  }

  isSystemSuperAdmin(): boolean {
    return localStorage.getItem('isSystemSuperAdmin') === 'true';
  }

  checkAdminAccess() {
    const userRole = this.adminSrvc.userRole;
    const isOrgSuperAdmin = JSON.parse(localStorage.getItem('isOrgSuperAdmin'));
    if (userRole === 'SA' || isOrgSuperAdmin) {
      return true;
    }
    return false;
  }

  checkPageAccess(pageUrl: string) {
    let status = true;
    const [initial, menu, page] = pageUrl.split('/');
    if (menu) {
      const allowedMenus = ['account', 'dev-console', 'generate-key', 'view-logs', 'access-docs', 'api-integration', 'data-mapping', 'settings', 'help', 'chat-with-users', 'tickets', 'ticket'];
      if (allowedMenus.includes(menu.toLowerCase())) {
        return true;
      }
      if (menu.toLowerCase() === 'admin') {
        if (page && page.toLowerCase().includes('subscription')) {
          return this.isSystemSuperAdmin();
        }
        return this.checkAdminAccess();
      }
      
      // Dynamically read from localStorage to avoid cached/stale values
      const encryptedMenus = localStorage.getItem('menu_access');
      const menuAccessList = encryptedMenus
        ? JSON.parse(this.util.decrypt(encryptedMenus))
        : (this.menuAccess || []);

      const isMenuExist = menuAccessList.find((ele: any) =>
        this.isEquivalent(ele.menu_name, menu)
      );
      if (!isMenuExist) {
        return false;
      }
      if (page) {
        // Automatically allow Revision History sub-routes for any authorized menu module
        if (pageUrl.toLowerCase().includes('revisionhistory') || pageUrl.toLowerCase().includes('revision-history')) {
          return true;
        }

        if (!isMenuExist.pages || !isMenuExist.pages.length) {
          return false;
        }
        const normalizeUrl = (url: string) =>
          url ? url.replace('/Content/', '/Library/').replace('/sales/', '/Customer/').replace('/Resources/', '/UserSettings/') : '';

        const isPageExist = isMenuExist.pages.find((ele: any) =>
          this.isEquivalent(normalizeUrl(ele.url), `/${menu}/${page}`)
        );
        if (!isPageExist) {
          const isInnerPresent = isMenuExist.pages.find(
            (ele: any) => ele.url === '/#' && !!ele.pages
          );
          if (!isInnerPresent) return false;
          const isInnerPagePresent = isInnerPresent.pages.find((ele: any) =>
            this.isEquivalent(normalizeUrl(ele.url), `/${menu}/${page}`)
          );
          if (!isInnerPagePresent) return false;
        }
      }
    }
    return status;
  }
}
